import { ytVueGlobalStore } from "@/services/yt-vue-global-store";
const phone = ytVueGlobalStore.instantGet('phone');
export default {
  namespaced: true,
  state: {
    phone: phone || "",
  },
};
